import {useState} from 'react'; 
import user from "@solimat/solimat-web-endpoint/lib/user"
 
const useGetCompleteUser = () => {
  const BASE_URL = import.meta.env.VITE_REACT_APP_USUARIOS_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_USUARIOS_KEY || "";
  const userService = new user.AuthService(BASE_URL, FUNCTIONS_KEY);
  const [loadingCompleteUser,setLoadingCompleteUser] = useState<boolean>(false)
  const [errorCompleteUser,setErrorCompleteUser] = useState<boolean>(false)
  const [completeUserResponse,setCompleteUserResponse] = useState<any|null>(null)

  const getCompleteUser = async (UserByIdentityRequest:any) => {
    setLoadingCompleteUser(true)
    setErrorCompleteUser(false)
    try {
      const response = await userService.GetCompleteUser(UserByIdentityRequest);
      setLoadingCompleteUser(false)
      setCompleteUserResponse(response.data)
      return response.data;
    } catch(err) {
      setLoadingCompleteUser(false)
      setErrorCompleteUser(true)
      console.error("getCompleteUser", err);
      return false
    }
  }
  const getCompleteUserById = async (userId : string) => {
    setLoadingCompleteUser(true)
    setErrorCompleteUser(false)
    try {
      const response = await userService.GetCompleteUser(userId);
      setLoadingCompleteUser(false)
      setCompleteUserResponse(response.data)
      return response.data;
    } catch(err) {
      setLoadingCompleteUser(false)
      setErrorCompleteUser(true)
      console.error("getCompleteUser", err);
      return false
    }
  }

  return {
    getCompleteUser,
    getCompleteUserById,
    loadingCompleteUser,
    errorCompleteUser,
    completeUserResponse,
  }
}

export default useGetCompleteUser;